import React, { useState } from "react";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function AdminPage() {
  const [token, setToken] = useState(null);
  
  if (!token) {
    return <AdminLogin onLogin={setToken} />;
  }
  
  return <AdminDashboard token={token} onLogout={() => setToken(null)} />;
}
